module.exports = __webpack_public_path__ + "img/fengxianpinggu.79fe64f8.png";